import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";

type Props = {
    title?: string;
    body?: React.ReactNode;
};

const Error = ({title, body}: Props): React.ReactElement => (
    <View style={styles.container}>
        <HeadingSmall>{title || t`Loading failed`}</HeadingSmall>
        <Body tag="p" style={styles.body}>
            {body || t`Content isn't loading right now. Refresh to try again.`}
        </Body>
    </View>
);

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        background: color.offBlack8,
        padding: "40px 0 18px",
        textAlign: "center",
        marginBottom: 48,
    },
    body: {
        marginTop: 8,
        maxWidth: 370,

        [mediaQueries.smOrSmaller]: {
            marginLeft: 30,
            marginRight: 30,
        },
    },
});

export default Error;
